import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Hito } from './hitos-procesales.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class HitosProcesalesService {

  private hitosURL: string = urlJoin(environment.apiURL, 'hitos')


  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getHitosExpediente(id_expediente: string): Observable<Hito[]> {
    const getHitosExpedienteURL = urlJoin(this.hitosURL, '/expediente/', id_expediente)
    return this.http.get<Hito[]>(getHitosExpedienteURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getHito(id: string): Observable<Hito> {
    const getHitoURL = urlJoin(this.hitosURL, id)
    return this.http.get<Hito>(getHitoURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newHito(hito: Hito): Observable<any> {
    return this.http.post<Hito>(this.hitosURL, hito)
      .pipe(
        tap(() => {
          const newHitoSuccessMessage: string = $localize`:@@newHitoSuccessMessage:Nuevo hito creado correctamente`;
          this.notificationsService.showSuccessNotification(newHitoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateHito(id: string, hito: Hito): Observable<any> {
    const updateHitoURL = urlJoin(this.hitosURL, id)
    return this.http.put<Hito>(updateHitoURL, hito)
      .pipe(
        tap(() => {
          const updatehitoSuccessMessage: string = $localize`:@@updatehitoSuccessMessage:Hito modificado correctamente`;
          this.notificationsService.showSuccessNotification(updatehitoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }


  deleteHito(id: string): Observable<any> {
    const deleteHitoURL = urlJoin(this.hitosURL, id.toString())
    return this.http.delete<Hito>(deleteHitoURL)
      .pipe(
        tap(() => {
          const deleteHitoSuccessMessage: string = $localize`:@@deleteHitoSuccessMessage:Hito eliminado correctamente`;
          this.notificationsService.showSuccessNotification(deleteHitoSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

}
